module.exports = __webpack_public_path__ + "img/T1A_xh_7.97d9ee88.png";